import JSZip from 'jszip'

const MIN_REGION_SIZE = 40;
const DEFAULT_CLASS_COLOR = '#1967D2'
export const ObjectDetectionColor =   ['#c60239', '#ff5733', '#ff8d18', '#ffc200', 
                        '#57c785', '#00baad', '#2a7a9b', '#3d3d6b', '#501849', '#900d3e']

export class ObjectDetectionRegion {
    constructor(classId = -1, x1 = 0, y1 = 0, x2 = 0, y2 = 0){
        this.classId = classId;
        this.x1 = x1; this.x2 = x2;
        this.y1 = y1; this.y2 = y2;
        this.top = 0; this.left = 0;
        this.width = 0; this.height = 0
        this.refigure();
    }

    refigure(){
        this.top = Math.min(this.y1, this.y2)
        this.height = Math.abs(this.y1 - this.y2)
        this.left = Math.min(this.x1, this.x2)
        this.width = Math.abs(this.x1 - this.x2)
    }

    isValid(){
        return this.width >= MIN_REGION_SIZE && this.height >= MIN_REGION_SIZE
    }
}

export class ObjectDetectionData {
    constructor(imageData = null){
        this.imageData = imageData;
        this.regions = [];
    }

    addRegion(region){
        this.regions.push(region)
    }

    removeRegion(targetRegion) {
        const indexToRemove = this.regions.findIndex(region => region == targetRegion)
        if (indexToRemove != -1) {
            this.regions.splice(indexToRemove, 1);
        }
    }
}

export class ObjectDetectionClass {
    constructor(id = null, name = '', color = ObjectDetectionColor[Math.floor(Math.random() * ObjectDetectionColor.length)]){
        this.id = id
        this.name = name;
        this.color = color;
    }

    setColor(color){
        this.color = color
    }

    setName(name){
        this.name = name
    }
}

export class ObjectDetectionTrainer {
    constructor(){
        this.classesCount = 0;
        this.classes = []
        this.data = []

        this.addClass();
    }

    addClass(name = 'Untitled') {
        const cls = new ObjectDetectionClass(+ +this.classesCount++, name)
        this.classes.push(cls)
        return cls
    }

    removeClass(id) {
        const indexToRemove = this.classes.findIndex(cls => cls.id === id);
        if (indexToRemove != -1) {
            for (let data of this.data) {
                data.regions = data.regions.filter(region => region.classId != id)
            }
            this.classes.splice(indexToRemove, 1);
        }
    }

    getClass(id){
        return this.classes.find(cls => cls.id == id)
    }

    getClasses(){
        return this.classes
    }

    addData(imageData) {
        const image = new ObjectDetectionData(imageData)
        this.data.push(image)
        return image
    }

    removeData(targetData){
        const indexToRemove = this.data.findIndex(data => data == targetData)
        if (indexToRemove != -1) {
            this.data.splice(indexToRemove, 1);
        }
    }

    countDataByClass(classId){
        let count = 0;
        for (let data of this.data) {
            count += data.regions.filter(region => region.classId == classId).length
        }
        return count
    }

    getData(){
        return this.data
    }

    async toBlob(){
        async function toBlob(canvas) {
            return new Promise((resolve, reject) => {
                canvas.toBlob((blob) => {
                    resolve(blob)
                })
            })
        }
        const toIndex = (id) => {
            return this.classes.findIndex(cls => cls.id === id) 
        }
        const zip = new JSZip();
        const json = []
        for (const [index, data] of this.data.entries()) {
            const fileName = `img${index}.jpg`

            const canvas = document.createElement("canvas");
            canvas.width = data.imageData.width;
            canvas.height = data.imageData.height;
            const ctx = canvas.getContext("2d");
            ctx.putImageData(data.imageData, 0, 0);
            const blob = await toBlob(canvas);
            zip.file(fileName, blob)

            const obj = {
                file: fileName,
                regions: data.regions.map(region => {
                    return [toIndex(region.classId), region.y1 / canvas.height, region.x1 / canvas.width, region.y2 / canvas.height, region.x2 / canvas.width]
                })
            }

            json.push(obj)
            console.log(obj.regions)
        }

        zip.file('labels.json', new Blob([JSON.stringify(json)], { type: "application/json" }))

        const blob = await zip.generateAsync({type:"blob"})
        return blob
    }

    async toBlobs(){
        const result = [];
        async function toBlob(canvas) {
            return new Promise((resolve, reject) => {
                canvas.toBlob((blob) => {
                    resolve(blob)
                })
            })
        }
        const toIndex = (id) => {
            return this.classes.findIndex(cls => cls.id === id) 
        }
        const json = []
        for (const [index, data] of this.data.entries()) {
            const fileName = `img${index}.jpg`

            const canvas = document.createElement("canvas");
            canvas.width = data.imageData.width;
            canvas.height = data.imageData.height;
            const ctx = canvas.getContext("2d");
            ctx.putImageData(data.imageData, 0, 0);
            const blob = await toBlob(canvas);
            result.push({name: fileName, blob: blob, mimetype: 'image/png'})

            const obj = {
                file: fileName,
                regions: data.regions.map(region => {
                    return [toIndex(region.classId), region.y1 / canvas.height, region.x1 / canvas.width, region.y2 / canvas.height, region.x2 / canvas.width]
                })
            }

            json.push(obj)
        }

        result.push({name: 'labels.json', blob: new Blob([JSON.stringify(json)]), mimetype: "application/json"})

        return result
    }
}